import '@fontsource/cormorant-garamond/500-italic.css'
import '@fontsource-variable/inter'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './context/AuthContext'
import './index.css'
import './review-task-desktop.css'

const Router = window.location.protocol === 'data:' ? HashRouter : BrowserRouter

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Route changes commit immediately; each page owns its loading state. */}
    <Router useTransitions={false}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Router>
  </StrictMode>,
)

